import { API, Storage } from 'aws-amplify';

// @ts-ignore
function cleanEmptyValue(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '') {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  });

  return obj;
}

// @ts-ignore
export const create = async (member) => API.put(
  'ihrespezialistenBackend',
  '/files',
  { body: cleanEmptyValue(member) },
);

export const read = async () => API.get('ihrespezialistenBackend', '/files', {});

// @ts-ignore
export const del = async (file) => API.del('ihrespezialistenBackend', `/files/${file.id}`, {});

// @ts-ignore
// tslint:disable-next-line:max-line-length
export const uploadFile = async (id, file) => Storage.put(`${id}`, file, { contentType: file.type });

// @ts-ignore
export const update = async (file) => API.post('ihrespezialistenBackend', `/files/${file.id}`,
  { body: cleanEmptyValue(file) });
